import Controls from "./Controls.svelte"
import Gallery from "./Gallery.svelte"

export default Object.assign(Gallery, { Controls })
